<div [routerLink]="botao.rota" type="button"
[ngClass]="botao.disableStyle == 'cinza-claro' && true == botao.disable ? 'cinza-claro' : '' "
[class]="'primary-orage '+ botao.estilo">
  <ng-container *ngIf="botao.leftIcon != null">

    <i [class]="'left-icon pi ' + botao.leftIcon"></i>
  </ng-container>
  {{ botao.titulo }}

  <ng-container *ngIf="botao.rightIcon != null">
    <i [class]="'right-icon pi ' + botao.rightIcon"></i>
  </ng-container>

</div>
